{
  "id": "monokai",
  "name": "Monokai",
  "description": "Monokai color scheme - vibrant and classic",
  "colors": {
    "light": {
      "primary": "#66D9EF",
      "secondary": "#AE81FF",
      "positive": "#A6E22E",
      "negative": "#F92672",
      "warning": "#E6DB74",
      "important": "#FD971F",
      "light": "#F8F8F2",
      "dark": "#272822",
      "surface": "#F5F5F0",
      "darksurface": "#3E3D32",
      "white": "#F8F8F2"
    },
    "dark": {
      "primary": "#66D9EF",
      "secondary": "#AE81FF",
      "positive": "#A6E22E",
      "negative": "#F92672",
      "warning": "#E6DB74",
      "important": "#FD971F",
      "light": "#F8F8F2",
      "dark": "#272822",
      "surface": "#F5F5F0",
      "darksurface": "#3E3D32",
      "white": "#F8F8F2"
    }
  }
}
